export class Model_CRM_FitMice {

    public FitMiceName: string;
    public FitMiceId: number;

}

